<div class="div-arriere-plan-action" (click)="onDismiss(false)"></div>
<div class="div-global-action"  style="text-align: center;" (click)="$event.stopPropagation()">
  <div id="center-square">
    <div style="display: flex; justify-content: space-between; flex-direction: column; height: 100%">
      <div *ngIf="!isAssessors" class="flex gap-10 content-center">
        <img class="close-icon" src="assets/close_cross_black.svg" (click)="onDismiss(false)">
        <h3 class="bold header_title light-blue">ENVOYER LA CONVOCATION ET L’ORDRE DU JOUR PAR E-MAIL</h3>
      </div>

      <p class="text-md dark-blue no-margin">Vous vous apprêtez à envoyer la convocation officielle à toutes les personnes invitées</p>

      <div class="text-container">
        <p class="text-md dark-blue no-margin">Attention, Vous pourrez relancer <span class="bold">2 fois</span> au
          maximum et à intervalle de <span class="bold">12 heures</span> minimum.</p>
      </div>
      <!-- <div class="dark-blue">
        <p class="text-md" style="margin: 5px 0px 5px 0px;">
          Votants n’ayant pas encore exprimé leur vote : <span class="bold text-lg">{{mails.length}}</span>
        </p>
      </div>

      <div class="voters-container">
        <div *ngFor="let mail of mails; let i = index">
          <div class="flex align-items-base" style="margin-bottom: 15px;">
            <p class="text-md dark-blue bold no-margin" style="margin-right: 10px;">{{i + 1}}.</p>
            <div style="flex: 1; margin-right: 20px;" class="ml-10">
              <p class="no-margin dark-blue text-md">toto</p>
              <p class="no-margin text-sm dark-blue opacity-60">{{mail.email}}</p>
            </div>
          </div>
        </div>
      </div> -->

      <div>
        <!-- <div class="download-button content-center align-items-center flex flex-row" (click)="downloadVoterFile()">
          <img src="assets/certificate-dl.svg" class="mr-10">
          <span class="download-text link-text">Fichier de votants</span>
        </div> -->

        <div style="display: flex; justify-content: space-between; flex-direction: column; align-items: center;">
          <button class="action-button" (click)="onDismiss(true)">Relancer</button>
          <p (click)=onDismiss(false) class="dark-blue pointer" style="margin-bottom: 0px;">Fermer</p>
        </div>
      </div>
    </div>
  </div>
</div>